import { render, staticRenderFns } from "./PersonalReport.vue?vue&type=template&id=52d1d37a&scoped=true&"
import script from "./PersonalReport.vue?vue&type=script&lang=js&"
export * from "./PersonalReport.vue?vue&type=script&lang=js&"
import style0 from "./PersonalReport.vue?vue&type=style&index=0&id=52d1d37a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d1d37a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow,VSnackbar,VSpacer})
